import { render, staticRenderFns } from "./AssignmentDistributionDialog.vue?vue&type=template&id=21fcbe49"
import script from "./AssignmentDistributionDialog.vue?vue&type=script&lang=js"
export * from "./AssignmentDistributionDialog.vue?vue&type=script&lang=js"
import style0 from "./AssignmentDistributionDialog.vue?vue&type=style&index=0&id=21fcbe49&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports